import SwaNonRevHomePage from './swaNonRevHomePage.component.js';

export default SwaNonRevHomePage;
